export const signatureFonts = [
  {
    id: "dancing-script",
    cssFamily: "'Dancing Script', cursive",
    apiValue: "Dancing Script",
  },
  {
    id: "great-vibes",
    cssFamily: "'Great Vibes', cursive",
    apiValue: "Great Vibes",
  },
  {
    id: "pacifico",
    cssFamily: "'Pacifico', cursive",
    apiValue: "Pacifico",
  },
];
